import { Component, OnInit, Input } from '@angular/core';
import { AerovaleDetalle } from '@shared/models/despacho/AerovaleDetalle';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { RanchoService } from '../rancho.service';
import { UsuarioService } from '@account/usuario.service';
import { Usuario } from '@shared/models/despacho/Usuario';
import { MessageService } from '@shell/message.service';
import { CuentaCliente } from '@shared/models/despacho/CuentaCliente';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-modal-modificar-aerovale',
  templateUrl: './modal-modificar-aerovale.component.html',
  styleUrls: ['./modal-modificar-aerovale.component.css']
})
export class ModalModificarAerovaleComponent implements OnInit {

  @Input() detalle: AerovaleDetalle;

  modificarForm: UntypedFormGroup;
  modificando: boolean = false;
  errorModificar: boolean = false;
  numeroCuentaCliente: string;
  cargandoClientes: boolean;  
  errorClientes: boolean;
  clientes: CuentaCliente[];

  constructor(public modal: NgbActiveModal,
              private fb: UntypedFormBuilder,
              private ranchoService: RanchoService,
              private messageService: MessageService,
              private modalAceptar: NgbModal,
              private usuarioService: UsuarioService,
              private spinner: NgxSpinnerService) { }

  ngOnInit() {
    this.numeroCuentaCliente = this.detalle.cliente.numeroCuenta;
    this.modificarForm = this.fb.group({
      clienteFormControl: new UntypedFormControl(null, Validators.required)
    });
    this.iniciarComponentes();
  }

  iniciarComponentes() {
    this.getClientes();
  }

  armarUsuario() {
    const u = new Usuario();
    u.id = this.usuarioService.getIdUsuario();
    u.nombreCompleto = this.usuarioService.getNombresCompletosUsuario();
    u.userName = this.usuarioService.getUsername();
    u.dni = this.usuarioService.getDniUsuario();

    return u;
  }

  modificarAerovale() {
    this.errorModificar = false;

      if (this.clienteFormControl.invalid || (this.clienteFormControl.value.length > 0 && typeof (this.clienteFormControl.value) === 'string')) {
        this.messageService.showErrorMessage("Debe ingresar un cliente válido.");
        return;
      }

      this.modificando = true;
      
      const cuentaCliente: CuentaCliente = this.clienteFormControl.value;

      this.ranchoService.modificarAerovale(this.detalle.id, cuentaCliente.ctA_SGC)
        .subscribe(result => {
          if (result) {
            this.messageService.showSuccessMessage(result);
            this.modal.close();
            this.modificarForm.reset();
          } else {
            this.modificando = false;
          }
          this.modificando = false;
        }, ()=> {
          this.modificando = false;
          this.messageService.showSuccessMessage('Hubo un error al intentar modificar el número de cuenta del cliente.');
        });

    }

    confirmCliente(): void {
      if (this.clienteFormControl.value.length > 0 && typeof (this.clienteFormControl.value) === 'string') {
        this.messageService.showErrorMessage("Debe ingresar un cliente válido.");
        this.clienteFormControl.setValue(null);
      }
    }

    formatterCliente = (x: { razonSocial: string, ctA_SGC: string }) => `${x.razonSocial} - ${x.ctA_SGC == null ? 'SIN CTA SGC' : x.ctA_SGC}`;

    selectCliente(e: any): void {
      this.clienteFormControl.setValue(e.item);
    }

    searchCliente = (text$: Observable<string>) =>
      text$.pipe(
        debounceTime(200),
        distinctUntilChanged(),
        map(term => this.clientes == null || term.length < 2 || this.cargandoClientes ? [] :
          this.clientes.filter(v => this.containsString(this.clienteFormControl.value, v.ctA_SGC, v.razonSocial)).slice(0, 10))
      )
  
      getClientes(): void {
        this.cargandoClientes = true;
        this.ranchoService.getClientesActivos()
          .subscribe(clientes => {
            clientes = clientes.map(a => Object.assign(new CuentaCliente(), a));
            this.clientes = clientes;
            this.cargandoClientes = false;
            if(this.clientes.length>0) {        
              this.clienteFormControl.setValue(this.clientes.find(c => c.ctA_SGC == this.numeroCuentaCliente));
            }
          }, () => this.errorClientes = true);
      }
  
      containsString(searchValue: string, ...searchIn: string[]): boolean {
        const concat = searchIn.toString();
        return concat.toLowerCase().indexOf(searchValue.toLowerCase()) > -1
      }
  
      get clienteFormControl() {
        return this.modificarForm.get('clienteFormControl');
      }
  }
